import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

function Textarea({ name, placeholder, ...rest }) {
  const textareaRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: textareaRef.current,
      getValue: ref => {
        return ref.value;
      },
      setValue: (ref, value) => {
        ref.value = value;
      },
      clearValue: ref => {
        ref.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      <textarea
        ref={textareaRef}
        className={error ? 'erro' : ''}
        placeholder={error || placeholder}
        {...rest}
      />
    </>
  );
}

export default Textarea;
